export default __webpack_public_path__ + "static/media/high-knee.1fe94bfd.png";